var map = {
	"./1.webp": 9760,
	"./bg.jpg": 8496,
	"./bg2.jpg": 6057,
	"./bg3.webp": 514,
	"./blue.jpg": 2658,
	"./code.jpg": 8831,
	"./ej.jp2": 655,
	"./ej.jpg": 5305,
	"./ej.jxr": 5411,
	"./ej.webp": 3942,
	"./epic.png": 4258,
	"./github.png": 4343,
	"./githubwhite.png": 305,
	"./globe.svg": 5917,
	"./linkedin.png": 8518,
	"./linkedin2.png": 2815,
	"./logo1.png": 9461,
	"./logo2.png": 9842,
	"./logo3.png": 6149,
	"./logo4.png": 8447,
	"./logo5.png": 9414,
	"./logo6.png": 6552,
	"./metadata.jpg": 3048,
	"./space.jpg": 7366,
	"./space2.jpg": 6975,
	"./space3.jpg": 3009,
	"./space4.jpg": 5925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;